import React, { useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Checkbox } from "sr/helpers";
import CheckBoxHandle from "sr/helpers/functions/CheckBoxHandle";
import getLabelByValue from "sr/helpers/functions/getLabelByValue";

export const ShowSelected = ({type, allTypes, setData}) => {
const intl = useIntl()

  return (
<>
             {
            type?.map((datI, index) =>  {                                    
             return <Checkbox
             divclass={'mr-3 mb-3 w-56'}
             key={index}
             id={datI}
             onChange={(e)=> CheckBoxHandle(e, type, setData)}
                    value={datI}
                    checked={datI}
                    // onChange={props?.onChange}
                    label={<FormattedMessage id={ getLabelByValue(datI || 'N/A', allTypes )}></FormattedMessage>}
                  />
            })}
</>  
);
};
